import IntroBlockEdit from './my-blocks/intro-block/Edit';
import IntroBlockView from './my-blocks/intro-block/View';
import IntroBlockIcon from '@plone/volto/icons/key.svg';

import HighlightBlockEdit from './my-blocks/highlight-block/Edit';
import HighlightBlockView from './my-blocks/highlight-block/View';
import HighlightBlockIcon from '@plone/volto/icons/highlighter.svg';

import MapBlockEdit from './my-blocks/map-block/Edit';
import MapBlockView from './my-blocks/map-block/View';
import MapBlockIcon from '@plone/volto/icons/world.svg';

import ZentrumsBlockEdit from './my-blocks/zentrums-block/Edit';
import ZentrumsBlockView from './my-blocks/zentrums-block/View';
import ZentrumsBlockIcon from '@plone/volto/icons/home.svg';

import PartnerBlockEdit from './my-blocks/partner-block/Edit';
import PartnerBlockView from './my-blocks/partner-block/View';
import PartnerBlockIcon from '@plone/volto/icons/user.svg';

import FoerdererBlockEdit from './my-blocks/foerderer-block/Edit';
import FoerdererBlockView from './my-blocks/foerderer-block/View';
import FoerdererBlockIcon from '@plone/volto/icons/heart.svg';

// New import for button-block
import ButtonBlockEdit from './my-blocks/button-block/Edit';
import ButtonBlockView from './my-blocks/button-block/View';
import ButtonBlockIcon from '@plone/volto/icons/bold.svg'; // Update icon if needed


export default function applyConfig(config) {
  config.settings = {
    ...config.settings,
    isMultilingual: false,
    supportedLanguages: ['de'],
    defaultLanguage: 'de',
  };

  config.blocks.requiredBlocks = [];

  // Configuration for intro block
  config.blocks.blocksConfig.intro_block = {
    id: 'intro_block',
    title: 'Intro Block',
    edit: IntroBlockEdit,
    view: IntroBlockView,
    icon: IntroBlockIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Configuration for highlight block
  config.blocks.blocksConfig.highlight_block = {
    id: 'highlight_block',
    title: 'Highlight Block',
    edit: HighlightBlockEdit,
    view: HighlightBlockView,
    icon: HighlightBlockIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Configuration for map block
  config.blocks.blocksConfig.map_block = {
    id: 'map_block',
    title: 'Map Block',
    edit: MapBlockEdit,
    view: MapBlockView,
    icon: MapBlockIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Configuration for zentrums block
  config.blocks.blocksConfig.zentrums_block = {
    id: 'zentrums_block',
    title: 'Zentrums Block',
    edit: ZentrumsBlockEdit,
    view: ZentrumsBlockView,
    icon: ZentrumsBlockIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Configuration for partner block
  config.blocks.blocksConfig.partner_block = {
    id: 'partner_block',
    title: 'Partner Block',
    edit: PartnerBlockEdit,
    view: PartnerBlockView,
    icon: PartnerBlockIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Configuration for foerderer block
  config.blocks.blocksConfig.foerderer_block = {
    id: 'foerderer_block',
    title: 'Förderer Block',
    edit: FoerdererBlockEdit,
    view: FoerdererBlockView,
    icon: FoerdererBlockIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Configuration for button block
  config.blocks.blocksConfig.button_block = {
    id: 'button_block',
    title: 'Button Block',
    edit: ButtonBlockEdit,
    view: ButtonBlockView,
    icon: ButtonBlockIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };


  return config;
}
